/* ==========================================================================
   SMOON — Landing « Boxer menstruel nuit » (adulte)
   Scopé sur [data-bn-root]. Aucun framework, aucune dépendance.

   Les carrousels reposent tous sur le défilement natif + scroll-snap : le JS
   ne fait que piloter les flèches, les points et la barre de progression.
   Si le script tombe, on garde un rail qui se swipe.
   ========================================================================== */
(function () {
  'use strict';

  var SEL = '[data-bn-root]';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Formatage prix — le gabarit vient de `shop.money_format`, passé par le
     Liquid dans le JSON de la carte. Shopify propose huit variables selon les
     séparateurs ; la boutique utilise `{{amount_with_comma_separator}} €`.
     N'en gérer qu'une partie fait afficher le gabarit brut à la cliente. */
  function money(cents, format) {
    var value = Number(cents || 0) / 100;

    function group(decimals, thousands, decimal) {
      var parts = value.toFixed(decimals).split('.');
      var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? int + decimal + parts[1] : int;
    }

    var fmt = format || (window.Shopify && window.Shopify.money_format);
    if (!fmt || fmt.indexOf('{{') === -1) return group(2, ' ', ',') + ' €';

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return group(2, ',', '.');
        case 'amount_no_decimals': return group(0, ',', '.');
        case 'amount_with_comma_separator': return group(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return group(0, ' ', ',');
        case 'amount_with_space_separator': return group(2, ' ', ',');
        case 'amount_with_period_and_space_separator': return group(2, ' ', '.');
        default: return group(2, ' ', ',');
      }
    });
  }

  /* ------------------------------------------------------------------------
     Révélation au scroll
     ------------------------------------------------------------------------ */
  function initReveal(root) {
    var items = $$('.bn-rev', root);
    if (!items.length) return;
    if (REDUCED || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------------
     Démonstration « allongée » — le trait du niveau de flux monte à l'entrée
     ------------------------------------------------------------------------ */
  function initDemo(root) {
    $$('[data-bn-demo]', root).forEach(function (demo) {
      if (REDUCED || !('IntersectionObserver' in window)) { demo.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          demo.classList.add('is-in');
          io.unobserve(e.target);
        });
      }, { threshold: 0.3 });
      io.observe(demo);
    });
  }

  /* ------------------------------------------------------------------------
     Galerie d'une carte produit : flèches, points, synchro au défilement.
     Le track est cherché DANS la carte : un rail parent qui contient
     plusieurs cartes ne peut donc pas piloter la galerie de la première.
     ------------------------------------------------------------------------ */
  function initGallery(card) {
    var gal = $('[data-bn-gal]', card);
    if (!gal) return;
    var track = $('[data-bn-track]', gal);
    if (!track) return;
    var slides = $$(':scope > li', track);
    if (slides.length < 2) return;

    var dots = $$('button', $('[data-bn-dots]', gal) || document.createDocumentFragment());
    var prev = $('[data-bn-prev]', gal);
    var next = $('[data-bn-next]', gal);

    function current() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function goTo(i) {
      var k = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: k * track.clientWidth, behavior: REDUCED ? 'auto' : 'smooth' });
    }
    function paint() {
      var k = current();
      dots.forEach(function (d, i) {
        if (i === k) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; paint(); });
    }, { passive: true });
    paint();
  }

  /* ------------------------------------------------------------------------
     Rails : barre de progression et flèches. Le défilement lui-même est natif
     (scroll-snap), le JS ne fait que refléter l'état et piloter les flèches.
     Toute la navigation est masquée s'il n'y a rien à faire défiler : la même
     structure sert donc à un rail qui ne déborde que sur mobile et à un slider
     desktop à quatre cartes.
     ------------------------------------------------------------------------ */
  function initRails(root) {
    $$('[data-bn-rail]', root).forEach(function (rail) {
      var nav = rail.parentNode.querySelector('[data-bn-railnav]');
      if (!nav) return;
      var fill = nav.querySelector('[data-bn-railbar] i');
      var prev = nav.querySelector('[data-bn-rail-prev]');
      var next = nav.querySelector('[data-bn-rail-next]');
      var raf = null;

      function step() {
        var first = rail.firstElementChild;
        if (!first) return rail.clientWidth;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function paint() {
        var max = rail.scrollWidth - rail.clientWidth;
        nav.classList.toggle('is-on', max > 2);
        if (max <= 2) return;
        if (fill) {
          var ratio = rail.clientWidth / rail.scrollWidth;
          fill.style.width = Math.max(18, ratio * 100) + '%';
          var travel = 100 / Math.max(ratio, 0.0001) - 100;
          fill.style.transform = 'translateX(' + (rail.scrollLeft / max) * travel + '%)';
        }
        if (prev) prev.disabled = rail.scrollLeft < 4;
        if (next) next.disabled = rail.scrollLeft > max - 4;
      }

      function slide(dir) {
        rail.scrollBy({ left: dir * step(), behavior: REDUCED ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { slide(-1); });
      if (next) next.addEventListener('click', function () { slide(1); });

      rail.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; paint(); });
      }, { passive: true });
      window.addEventListener('resize', paint, { passive: true });
      paint();
    });
  }

  /* ------------------------------------------------------------------------
     Sélecteur de taille + ajout au panier AJAX
     ------------------------------------------------------------------------ */
  function initCard(card) {
    initGallery(card);

    var form = $('[data-bn-form]', card);
    var select = $('[data-bn-variant]', card);
    var idInput = $('[data-bn-id]', card);
    var addBtn = $('[data-bn-add]', card);
    var label = $('[data-bn-lbl]', card);
    var priceEl = $('[data-bn-price]', card);
    var wasEl = $('[data-bn-was]', card);
    if (!form || !addBtn) return;

    var data = {};
    var json = $('[data-bn-json]', card);
    if (json) { try { data = JSON.parse(json.textContent); } catch (e) { data = {}; } }
    var variants = data.variants || [];

    /* `paintPrice` reste faux au premier appel : le prix rendu par Liquid côté
       serveur fait foi tant que la cliente n'a pas changé de variante. */
    function sync(paintPrice) {
      if (!select) return;
      var id = parseInt(select.value, 10);
      var v = null;
      for (var i = 0; i < variants.length; i++) { if (variants[i].id === id) { v = variants[i]; break; } }
      if (idInput) idInput.value = String(id);
      if (!v) return;
      if (paintPrice) {
        if (priceEl) priceEl.textContent = money(v.price, data.moneyFormat);
        if (wasEl) {
          if (v.compare && v.compare > v.price) { wasEl.textContent = money(v.compare, data.moneyFormat); wasEl.hidden = false; }
          else { wasEl.hidden = true; }
        }
      }
      addBtn.disabled = !v.available;
      if (label) label.textContent = v.available ? (data.labelAdd || 'Ajouter au panier') : (data.labelOut || 'Épuisé');
    }

    if (select) select.addEventListener('change', function () { sync(true); });
    sync(false);

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;           /* très vieux navigateur : POST natif */
      e.preventDefault();
      if (addBtn.disabled) return;

      addBtn.classList.add('is-busy');
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = new FormData(form);
      if (drawer && drawer.getSectionsToRender) {
        body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        body.append('sections_url', window.location.pathname);
      }

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message);
          if (drawer && drawer.renderContents) {
            if (drawer.classList) drawer.classList.remove('is-empty');
            drawer.renderContents(res);
            if (drawer.open) drawer.open();
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function () {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .then(function () { addBtn.classList.remove('is-busy'); });
    });
  }

  function initCards(root) { $$('[data-bn-card]', root).forEach(initCard); }

  /* ------------------------------------------------------------------------
     Barre d'achat collante (mobile)
     ------------------------------------------------------------------------ */
  function initSticky(root) {
    var bar = $('[data-bn-sticky]', root);
    if (!bar || !('IntersectionObserver' in window)) return;
    var hero = $('[data-bn-hero]', root);
    var buy = $('[data-bn-buy]', root);
    var pastHero = !hero;
    var onBuy = false;

    function paint() { bar.classList.toggle('is-on', pastHero && !onBuy); }

    if (hero) {
      new IntersectionObserver(function (e) { pastHero = !e[0].isIntersecting; paint(); }, { threshold: 0 }).observe(hero);
    }
    if (buy) {
      new IntersectionObserver(function (e) { onBuy = e[0].isIntersecting; paint(); }, { threshold: 0 }).observe(buy);
    }
    paint();
  }

  /* ------------------------------------------------------------------------
     Ancres internes
     ------------------------------------------------------------------------ */
  function initAnchors(root) {
    $$('[data-bn-scroll]', root).forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById(a.getAttribute('data-bn-scroll'));
        if (!target) return;
        e.preventDefault();
        var header = document.querySelector('.section-header, sticky-header, header');
        var off = header && header.offsetHeight < 200 ? header.offsetHeight : 0;
        var y = target.getBoundingClientRect().top + window.pageYOffset - off - 12;
        window.scrollTo({ top: y, behavior: REDUCED ? 'auto' : 'smooth' });
      });
    });
  }

  /* ------------------------------------------------------------------------
     Modale guide des tailles
     ------------------------------------------------------------------------ */
  function initGuide(root) {
    var modal = $('[data-bn-modal]', root);
    if (!modal) return;
    var last = null;

    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (last && last.focus) last.focus();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    function open(trigger) {
      last = trigger;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      var btn = $('[data-bn-modal-close]', modal);
      if (btn) btn.focus();
    }

    $$('[data-bn-guide]', root).forEach(function (b) {
      b.addEventListener('click', function () { open(b); });
    });
    modal.addEventListener('click', function (e) {
      if (!e.target.closest('.bn-modal__box') || e.target.closest('[data-bn-modal-close]')) close();
    });
  }

  /* ------------------------------------------------------------------------
     Agrandissement d'une image de carte, comme sur les fiches produit.
     Une seule lightbox pour toute la page : on lui passe la galerie de la
     carte cliquée et l'index de l'image.
     ------------------------------------------------------------------------ */
  function initZoom(root) {
    var lb = $('[data-bn-lb]', root);
    if (!lb) return;

    var img = $('[data-bn-lb-img]', lb);
    var count = $('[data-bn-lb-count]', lb);
    var prev = $('[data-bn-lb-prev]', lb);
    var next = $('[data-bn-lb-next]', lb);
    var shots = [];
    var at = 0;
    var opener = null;

    function paint() {
      var s = shots[at];
      if (!s) return;
      img.src = s.src;
      img.alt = s.alt;
      if (count) count.textContent = at + 1 + ' / ' + shots.length;
      var solo = shots.length < 2;
      if (prev) prev.hidden = solo;
      if (next) next.hidden = solo;
    }
    function move(step) {
      at = (at + step + shots.length) % shots.length;
      paint();
    }
    function close() {
      lb.hidden = true;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (opener && opener.focus) opener.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') move(-1);
      else if (e.key === 'ArrowRight') move(1);
    }
    function open(slides, index, from) {
      shots = slides;
      at = index;
      opener = from;
      paint();
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      var c = $('[data-bn-lb-close]', lb);
      if (c) c.focus();
    }

    $$('[data-bn-track] img', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var track = thumb.closest('[data-bn-track]');
        var items = $$(':scope > li', track);
        var slides = items.map(function (li) {
          var i = li.querySelector('img');
          return { src: li.getAttribute('data-bn-full') || (i && i.currentSrc) || '', alt: (i && i.alt) || '' };
        });
        open(slides, items.indexOf(thumb.closest('li')), thumb);
      });
    });

    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-bn-lb-close]') || !e.target.closest('.bn-lb__stage')) close();
    });

    /* balayage horizontal sur mobile */
    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) move(dx < 0 ? 1 : -1);
      x0 = null;
    }, { passive: true });
  }

  /* ------------------------------------------------------------------------
     FAQ : un seul panneau ouvert. Le balisage reste <details> natif.
     ------------------------------------------------------------------------ */
  function initFaq(root) {
    var items = $$('.bn-faq__i', root);
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ------------------------------------------------------------------------ */
  function boot(root) {
    if (root.dataset.bnReady === '1') return;
    root.dataset.bnReady = '1';
    initReveal(root);
    initDemo(root);
    initCards(root);
    initRails(root);
    initSticky(root);
    initAnchors(root);
    initGuide(root);
    initZoom(root);
    initFaq(root);
  }

  function bootAll() { $$(SEL).forEach(boot); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
  else bootAll();

  document.addEventListener('shopify:section:load', function (e) {
    $$(SEL, e.target).forEach(function (r) { r.dataset.bnReady = ''; boot(r); });
  });
})();
